module.exports = __webpack_public_path__ + "images/mdj/members/common/modal-close-0cd8950f995d02d32a8a86bfdc794adb.png";